import { DateRangeModel } from 'forms/shared/types';
import { today, dateWithinMonthYearSafeRange } from 'helpers/date';

/** Helpers */
export const educationRequiresReference = (dates?: DeepSafePartial<DateRangeModel>) => {
  if (dates === undefined) { return false; }

  const { from, present } = dates;
  const to = present ? today.toObject() : dates.to;
  const safeRange = today.minus({ years: 3 });
  return dateWithinMonthYearSafeRange(to, safeRange) || dateWithinMonthYearSafeRange(from, safeRange);
};

export const educationRequiresPhysicalLocationAndReference = (dates?: DeepSafePartial<DateRangeModel>) => {
  if (dates === undefined) { return false; }

  const { from, present } = dates;
  const to = present ? today.toObject() : dates.to;
  const safeRange = today.minus({ years: 5 });
  return dateWithinMonthYearSafeRange(to, safeRange) || dateWithinMonthYearSafeRange(from, safeRange);
};
